/**
 * Converts the date to a server format
 * @param {string} date
 * @returns {string}
 */
import * as moment from 'moment-mini-ts';

export const setServerDateFormat = (date: string): string => {
  return moment(date).format('YYYY-MM-DD');
};

export const setUrlDateFormat = (date: string) => {
  return moment(date, 'DD/MM/YYYY');
}

/**
 * Converts the date to a client format
 * @param {string} date
 * @returns {string}
 */
export const setClientDateFormat = (date: string) => {
  return moment(date).format('DD.MM.YYYY');
};
